import { Component, h, Prop, Event, EventEmitter, Watch, State } from '@stencil/core';
import { requestResetPassword } from '../../../components/hd-auth/requests';
import AuthHeader from "../auth-header";

@Component({
  tag: 'hd-check-inbox',
  shadow: false
})
export class HdCheckInbox {
  @Prop({ mutable: true }) type: "provider" | "recover" | "check-inbox" = "check-inbox";
  @Prop() email: string = ""
  @Prop() url: string;

  @Event() recoverStep: EventEmitter<{ type: string }>;

  @State() loading = false;
  @State() errorFormFields: Record<string, boolean | null> = {
    email: null
  };

  handleError = (error: any, target: HTMLInputElement) => {
    const parentGroup = target.parentElement.parentElement;
    const errorElement = parentGroup.querySelector(".error-message");

    if (!parentGroup || !errorElement) {
      return;
    }

    parentGroup.classList.toggle("has-error", !!error);
    errorElement.textContent = error.status === 400 ? error.message : "We couldn't process your request. Please try again later.";
    this.loading = false;
    this.errorFormFields.email = false;
  }

  resend = async (target: HTMLInputElement) => {
    try {
      this.loading = true;
      const res = await requestResetPassword(this.url, this.email)

      if (!res) {
        this.handleError({ message: "No response from server", status: 500 }, target);
        return;
      }

      window.setTimeout(() => {
        this.loading = false;
      }, 600);

      this.type = "check-inbox";
    } catch (error) {
      this.handleError(error, target);
    }
  }

  @Watch("type")
  typeChanged() {
    this.recoverStep.emit({ type: this.type })
  }

  render() {
    return (
      <div class="step-container check-inbox">
        {this.type === "check-inbox" && (
          <AuthHeader
            title="Check your inbox"
            subhead={`We’ve sent a password reset link to your email ${this.email}. Please check your inbox and follow the instructions to create a new password.`}
          />)}
        <div class="step-actions">
          <p class="error-message"></p>
          <hd-button primary padded
            disabled={this.loading}
            onClick={() => {
              this.type = "provider"
            }}>
            {this.loading ? <hd-icon svg="loader_bouncing_circles" width="24" height="24" /> : 'OK, got it'}
          </hd-button>
          <p>Didn’t receive the email?</p>
          <p class="login-link"><span onClick={(e) => this.resend(e.target as HTMLInputElement)}>Resend email</span> or <span onClick={() => this.type = "recover"}>Change email</span></p>
        </div>
      </div>
    )
  }
}